import React from 'react';
import './PostSkeleton.css';

interface PostSkeletonProps {
    count?: number;
}

const PostSkeleton: React.FC<PostSkeletonProps> = ({ count = 1 }) => {
    const skeletons = Array.from({ length: count }, (_, index) => (
        <article key={index} className="PostSkeleton">
            <section className="header">
                <div className="header-actions">
                    <div className="skeleton-liker" />
                </div>
                <div className="skeleton-title" />
                <div className="skeleton-details">
                    <div className="skeleton-avatar" />
                    <div className="skeleton-author" />
                    <div className="skeleton-date" />
                </div>
            </section>
            <section className="bd">
                <div className="skeleton-image" />
            </section>
            <section className="skeleton-description">
                <div className="skeleton-line" />
                <div className="skeleton-line short" />
            </section>
            <section className="comments">
                <div className="skeleton-comment-form" />
            </section>
        </article>
    ));

    return <>{skeletons}</>;
};

export default PostSkeleton;